<i *ngIf="valid === true" [ngClass]="validIcon" class="fa" aria-hidden="true"></i><i *ngIf="valid !== true" class="fa" [ngClass]="invalidIcon" aria-hidden="true"></i>
